const state = () => ({	
	dialogList: new Array(), // 对话容器，用于更新对话列表
	modalData: { // 弹窗信息
		modalType: "", 
		isShowModal: false,
		delType: 'dialog',
		dialog: new Object() // 删除单条对话时 用于传递当前对话数据
	},
	insertDialog: { 
		insertType: '', // 插入的对话类型 above / blown
		baseRole: new Object() // 向上/下 基于的对话数据
	},
	inputValueDialog: '', // input输入框 value
	editValue: '', // 编辑 textarea 的值 对话的
	isHighLine: false, // 正在高亮编辑的状态
	branchTextarea: { // 用于暂存分支title textarea 控制修改/增加/删除
		1: '',
		2: '',
		3: '',
		4: '',
		5: '',
		6: '',
		7: '',
		8: '',
		9: '',
		10: ''
	},
	searchLocalId: 'option_1_dialogList', // 用于存储切换的对话查找key
	option: '', // 切换到分支对话时，显示header-tab的title
	dialog_max_number: 0, // 所有的对话列表中 最大的 dialog_number ，数据获取自本地所有的对话列表的总和进行筛选
	uploadData: new Object(),
	axiosData: new Object(),
	uploadImgDialog: new Object(),
	uploadType: '',
	narration: [
		{	
			id: 0,
			main: 0, // 旁白
			rolename: "Narration",
			sex: 0, // 旁白
			icon: 0,
		}
	],
	roleDialog:new Object(),
	isUploading: false
})

// getters
const getters = {
	
}

// actions
const actions = {
	initAllDialogListFn({ commit, state }, {total_dialogList}) {  // 处理从数据库拉取的数据 添加属性 排序 设置本地缓存
		commit('initAllDialogList', {total_dialogList})
		commit('getMaxDialogNumber', null)
	},
	initFirstDialogFn({ commit, state }) { // 初始化主对话列表
		commit('initFirstDialog', null)
		commit('getMaxDialogNumber', null)
	},
	initBranchDialogFn({ commit, state }, {searchLocalId}) { // 初始化隶属分支的对话列表
		commit('initLocalBranchDialog',{searchLocalId})
		commit('getMaxDialogNumber', null)
	},
	toggleEditStatus({ commit, state }, dialog) { //点击编辑icon，如果当前有一个对话正在编辑状态，则点击无效
		commit('toggleEditStatusFn', dialog)
		commit('updateEditStatusFn', dialog) 
	},
	modalSaveDialogFn({ commit, state }) { // 插入一个对话，但是只在渲染列表 dialog_list中新增一条对话，不存本地缓存
		commit('closeModalFn', null)
		commit('max_dialog_number')
		commit('insertNewDialog', null)
	},
	addOptionDialogFn({ commit, state }, type) { // 弹窗新增 option  // 新增一个 option 以后，需要执行一个回掉，检测是否 其他的 option 是否有编辑状态，如果有就关闭
		commit('closeModalFn', null)
		commit('clearOptionInputStatus', null) // 判断如果现有分支对话中含正在打开的输入框 先清空
		commit('max_dialog_number')
		commit('renderNewOption', type) 
		commit('initTextarea', null) // 清空所有的 branchTextarea 属性值 长度恢复成 2 
		commit('setLocalstroge', null)
	},
	toggleAvatarFn({ commit, state },dialog) {
		commit('toggleAvatar', dialog)
	},
	updateDialog({ commit, state },dialog) {
		commit('closeModalFn', dialog)
		commit('setLocalstroge', null)
	},
	addOptionBranchFn({ commit, state }, optionDialog) {
		commit('clearOptionInputStatus', null) // 先清除所有 branch 的输入状态
		commit('addBranchFn', optionDialog) // 给分支 新增一个输入框 ，需要修改其他的分支的 输入框的输入状态为隐藏
		commit('initTextarea', null)
		commit('setLocalstroge', null)
	},
	delDialogFn({ commit, state }, dialog) {
		commit('closeModalFn', null)
		if (dialog.type === 3) {
			commit('delOptionLocalStorge', dialog)// 删除本地 localStorge 中对应的branch 对话列表
			commit('delDialog',dialog.dialog_number)
		} else {
			commit('delDialog',dialog.dialog_number)
		}
		commit('setLocalstroge', null)
	},
	inputSubmitFn({ commit, state }, inputDialog) {
		commit('max_dialog_number')
		commit('submitDialogFn', inputDialog) // 如果填充的数据 为空 不应该存储和生成缓存，但是影响不大 可以忽略
		commit('setLocalstroge', null)
	},
	insertImgFn({ commit, state }, {imgUrl,image_md5,insertDialog,type}) {
		commit('max_dialog_number')
		if (type === 'inputImg') {
			commit('insertInputImg', {imgUrl,image_md5,insertDialog})
		} else {
			commit('insertModalImg', {imgUrl,image_md5,insertDialog})
			commit('insertNewDialog', null)
		}
		commit('setLocalstroge', null)
	},
	okEditDialogFn({ commit, state }, dialog) { // 1 这里分为编辑对话，重置本地缓存 2 确认插入新对话，插入本地缓存
		commit('okEditDialog', dialog)
		commit('setLocalstroge', null)
	},
	editDialogAvatarFn({ commit, state }, dialog) {
		commit('editDialogAvatar', dialog)
		commit('setLocalstroge', null)
	},
	cancleEditDialogFn({ commit, state }, dialog) {
		commit('cancleEditDialog', dialog)
		commit('setLocalstroge', null)
	},
	saveBranchFn({ commit, state },branch) {
		commit('saveBranch', branch)
		commit('setLocalstroge', null)
	},
	editBranchFn({ commit, state },branch) {
		commit('editBranch', branch)
		commit('setLocalstroge', null)
	},
	delBranchFn({ commit, state },branch) {
		commit('delBranch', branch)
		commit('setLocalstroge', null)
	},
	uploadImgDataFn({ commit, state }, {axiosData, ImgData, uploadType}) {
		commit('_uploadImgDataFn', {axiosData, ImgData, uploadType})
		commit('clickEvent')
	}
}

// mutations
const mutations = {
	initAllDialogList(state, {total_dialogList}) {  // 获取 请求的对话列表 或者 从本地拉取的对话列表
		state.dialogList = new Array()
		if (total_dialogList.length === 0) {
			return false
		}
		// 给所有的对话都添加search_key
		total_dialogList.forEach(item => {
			item.search_key = ''
		})
		// 查找所有的分支对话
		const option_Array = total_dialogList.filter(item => {
			return item.type === 3
		})
		
	    if (option_Array.length > 0) {
			// // 根据jump 添加search_key 是否有值 是否显示关闭icon
			option_Array.forEach(item => {	
				let option_list = JSON.parse(item.option_list)
				option_list.forEach((Jtem,index) => {
					Jtem.search_key = `${item.dialog_number}_${index+1}`
					Jtem.parent_dialog = item.dialog_number
					Jtem.isValue = true
					Jtem.isClose = false
					Jtem.id = index + 1
					if (option_list.length > 2) {
						Jtem.isClose = true
					} 
				})
				item.option_list = option_list
			})
			// 根据 search_key 查找相关对话 
			let findNextDialogFn = function(aboveDialog, search_key) {
				const nextDialog = total_dialogList.find(item => {
					return item.parent_dialog === aboveDialog.dialog_number
				})
				if (nextDialog) {
					nextDialog.search_key = search_key
					findNextDialogFn(nextDialog, search_key)
				}
			}
			option_Array.forEach(item => {
				item.option_list.forEach(Jtem => {
					const branchFirstNum = Jtem.jump
					let search_key = Jtem.search_key
					if (branchFirstNum !== 0) {
						const branchFirstDialog = total_dialogList.find(Xtem => {
							return Xtem.dialog_number === branchFirstNum
						})
						branchFirstDialog.search_key = search_key
						findNextDialogFn(branchFirstDialog, search_key)
					}
				})
			})
		}
		
		// 查找所有的一般对话 添加角色信息和编辑状态
		const normal_Array = total_dialogList.filter(item => {
			return item.type === 0
		})
		let role_list = JSON.parse(localStorage.getItem('role_list')) 
		function compare(main){
		     return function(a,b){
		         var value1 = a[main];
		         var value2 = b[main];
		         return value2 - value1;
		     }
		}
		role_list.sort(compare('main'))
		role_list.unshift(...role_list.splice(role_list.findIndex(i => i.id === 0), 1))
		role_list.forEach((item,index) => {
			item._id = index
			if (item.icon < 10 && item.icon > 0) {
				item.icon = `0${item.icon}`
			} 
		})
		if (normal_Array.length > 0) {
			// 给所有的普通对话类型的 添加前端属性
			normal_Array.forEach(item => {
				const defaultSet = {
					isEdit: false,
					isInsert: false,
					main: 0,
					rolename: 'Narration',
					roleSex: 0,
					roleImage: 0
				}
				if (item.role !== 0) {
					const active_role = role_list.find(Jtem => {
						return parseInt(Jtem.id) === item.role 
					})
					defaultSet.main = active_role.main
					defaultSet.rolename = active_role.rolename
					defaultSet.roleSex = active_role.sex
					defaultSet.roleImage = active_role.icon
				} 
				Object.assign(item,defaultSet)	
			})
		}
		// 需要做处理，把totalDialogList 拆分成 1_dialogList 和 根据 search_key 抽离数据组
		state.searchLocalId = 'option_1_dialogList'
		let totalArray = {} // 创建对象 用于接受 分组后的对话
		// 查找 search_key 值为空的对话，设置为第一层对话
		const first_dialog = total_dialogList.filter(item => {
			return item.search_key === ''
		})
		totalArray['option_1_dialogList'] = first_dialog
		// 查找 search_key 对应的对话列表 
		total_dialogList.forEach(item => {
			if (item.type === 3) {
				item.option_list.forEach(Jtem => {
					const option_dialog = total_dialogList.filter(Ztem => {
						return Ztem.search_key === Jtem.search_key
					})
					if (option_dialog.length > 0) {
						totalArray[`option_${Jtem.search_key}`] = option_dialog
					}
				})
			}
		})
		// 经过下面的方法进行排序以后，数据按照分组 且阅读顺序正确
		// jump 值的算法为： 根据search_key 查找本地的对话小组，找到第一条的dialog_number就是jump的数字
		for(let _key in totalArray){
		   let new_arr = {},
		   	_news = []
			totalArray[_key].forEach(item => {
				const key = item.parent_dialog
				new_arr[key] = item
			})
			const first_dialog = new_arr[0]
			_news.push(first_dialog)
			let nextKey = first_dialog.dialog_number
			function loadNum(nextKey) {
				if (new_arr[nextKey]) {
					_news.push(new_arr[nextKey])
					nextKey = new_arr[nextKey].dialog_number
					loadNum(nextKey)
				}
			}
			loadNum(nextKey)
			if (_key === 'option_1_dialogList') {
				state.dialogList = _news
			}
			localStorage.setItem(_key,JSON.stringify(_news))
		}
	},
	initFirstDialog(state) { // 切换到主对话，从本地拉取对话列表
		state.searchLocalId = 'option_1_dialogList'
		state.dialogList = JSON.parse(localStorage.getItem('option_1_dialogList'))
	},
	initLocalBranchDialog(state, {searchLocalId}) { // 切换到分支对话上 ，动态传入 search_key
		state.searchLocalId = searchLocalId
		const localBranchDialogList = localStorage.getItem(searchLocalId) 
		if (localBranchDialogList !== null) {
			state.dialogList = JSON.parse(localBranchDialogList)
		} 
	},
	setLocalstroge(state) { // 设置本地缓存
		localStorage.setItem(state.searchLocalId,JSON.stringify(state.dialogList))
	},
	checkModalRoles(state, item) { // 弹窗切换角色
		state.insertDialog.baseRole.main = item.main
		state.insertDialog.baseRole.role = item.id
		state.insertDialog.baseRole.rolename = item.rolename
		state.insertDialog.baseRole.roleImage = item.icon
		state.insertDialog.baseRole.roleSex = item.sex
	},
	updateInputValue(state, value) { // 暂存角色输入的对话内容 点击发送对话按钮时 填充此value
		state.inputValueDialog = value
	},
	updateDialog(state, value) {
		state.editValue = value	
	},
	submitDialogFn(state, inputDialog) {  // submit dialog input 输入框提交 
		if (state.inputValueDialog.length !== 0) {
			inputDialog.title = state.inputValueDialog
			if (state.dialogList.length === 0) {
				inputDialog.parent_dialog = 0
				inputDialog.dialog_number = state.dialog_max_number + 1
			} else if (state.dialog_max_number === 0) {
				inputDialog.dialog_number = 1
			} else {
				inputDialog.parent_dialog = state.dialogList[state.dialogList.length -1].dialog_number
				inputDialog.dialog_number = state.dialog_max_number + 1
			}
			const newDialog = Object.assign({},inputDialog)
			state.dialogList.push(newDialog)
			state.inputValueDialog = ""
		}
	},
	insertInputImg(state, {imgUrl,image_md5,insertDialog}) {  // submit image
		insertDialog.image = imgUrl
		insertDialog.image_md5 = image_md5
		insertDialog.type = 1
		if (state.dialogList.length === 0) {
			insertDialog.parent_dialog = 0
			insertDialog.dialog_number = state.dialog_max_number + 1
		} else if (state.dialog_max_number === 0) {
			insertDialog.dialog_number = 1
		} else {
			insertDialog.parent_dialog = state.dialogList[state.dialogList.length -1].dialog_number
			insertDialog.dialog_number = state.dialog_max_number + 1
		}
		const newDialog = Object.assign({},insertDialog)
		state.dialogList.push(newDialog)
		state.inputValueDialog = ""
		state.isUploading = false
	},
	insertModalImg(state, {imgUrl,image_md5,insertDialog}) {
		insertDialog.baseRole.type = 1
		insertDialog.baseRole.id = 0
		insertDialog.baseRole.main = 0
		insertDialog.baseRole.role = 0
		insertDialog.baseRole.roleImage = 0
		insertDialog.baseRole.roleSex = 0
		insertDialog.baseRole.rolename = 'Narration'
		insertDialog.baseRole.image = imgUrl
		insertDialog.baseRole.image_md5 = image_md5
		insertDialog.baseRole.isEdit = false
		state.insertDialog = insertDialog
		state.isUploading = false
	},
	toggleEditStatusFn(state, _dialog) { // 切换编辑状态 对话列表中只允许存在一个输入编辑框  返回 true / false 如果有正在编辑的对话 则此次点击编辑动作无效
		const dialogArray = state.dialogList.filter(item => {
			return item.dialog_number !== _dialog.dialog_number
		})
		if (dialogArray.length > 0) {
			dialogArray.forEach(item => {
				if (item.type !== 3 && item.isEdit) {
					if (item.isInsert) {
						item.isInsert = false
						item.title= '...'
					}
					item.isEdit = false
				}
			})
		}
	},
	updateEditStatusFn(state, _dialog) {  // 更新 对话列表中的对话编辑状态
		const dialog = state.dialogList.find(item => {
			return item.dialog_number === _dialog.dialog_number
		})
		state.editValue = dialog.title
		dialog.isEdit = true
	},
	okEditDialog(state, dialogItem) { // 如果为插入文本 初次点击取消的时候会删除 
		const dialog = state.dialogList.find(item => {
			return item.dialog_number === dialogItem.dialog_number
		})
		if(dialogItem.isInsert) { 
			if (state.editValue.length == 0) {
				state.dialogList = state.dialogList.filter(item => item.dialog_number !== dialogItem.dialog_number)
			} else {
				dialog.title = state.editValue
				dialog.isEdit = false
				dialog.isInsert = false 
			}
			return 
		} 
		if (state.editValue.length > 0) {
			dialog.title = state.editValue
			dialog.isEdit = false
			return 
		} 
		dialog.isEdit = false
	},
	cancleEditDialog(state, dialogItem) { // 取消编辑对话
		if (dialogItem.isInsert) {
			state.dialogList = state.dialogList.filter(item => item.dialog_number !== dialogItem.dialog_number)
		} else {
			const dialog = state.dialogList.find(item => {
				return item.dialog_number === dialogItem.dialog_number
			})
			dialog.isEdit = false
		}
	},
	editDialogAvatar(state, dialogItem) {
		let dialog_index = state.dialogList.findIndex(item => {
			return item.dialog_number === dialogItem.dialog_number
		})
		state.dialogList[dialog_index] = dialogItem
	},
	 // 打开弹窗 插入对话 向上 / 向下
	openAddDialogModal(state, {type,baseDialog}) { // 打开添加对话 弹窗
		const isEditDialog = state.dialogList.find(item => {
			return item.isEdit // 打开插入文本对话框前 先检查页面是否有正在编辑的对话 
		})
		// 如果有正在编辑的输入框，则高亮显示这个输入框
		if (isEditDialog) { 
			state.isHighLine= true
			setTimeout(() => {
				state.isHighLine= false
			},2600)
			return 
		} 
		state.editValue = ""
		state.modalData.modalType = 'insertDialog'
		state.modalData.isShowModal = true
		state.insertDialog.insertType = type
		state.insertDialog.baseRole = Object.assign({},baseDialog) 
		state.insertDialog.baseRole.id = 0
		state.insertDialog.baseRole.type = 0
		state.insertDialog.baseRole.title = ''
		state.insertDialog.baseRole.option_list = ''
		state.insertDialog.baseRole.image = ''
		state.insertDialog.baseRole.image_md5 = ''
		state.insertDialog.baseRole.isEdit = true
		state.insertDialog.baseRole.isInsert = true
		if(baseDialog.type === 3 || baseDialog.type === 1) {
			state.insertDialog.baseRole.main = 0
			state.insertDialog.baseRole.rolename = 'Narration'
			state.insertDialog.baseRole.roleSex = 0
			state.insertDialog.baseRole.roleImage = 0
		}
	},
	closeModalFn(state) {  // 关闭弹窗
	 	state.modalData.isShowModal = false
	},
	insertNewDialog(state) { // 向上/下插入对话  如果是基于分支添加对话 则清空 分支对话内容 修改 type 为 0 (0 表示添加普通对话) 
		// 根据 基础对话 查找此对话的 index 查找上一条和下一条对话
		const activeDialogIndex = state.dialogList.findIndex(item => {
			return state.insertDialog.baseRole.dialog_number === item.dialog_number
		})
		const activeDialog = state.dialogList.find(item => {
			return state.insertDialog.baseRole.dialog_number === item.dialog_number
		})
		const prevDialog = state.dialogList[activeDialogIndex-1]
		const nextDialog = state.dialogList[activeDialogIndex+1]
		state.insertDialog.baseRole.dialog_number = state.dialog_max_number + 1
		if (state.insertDialog.insertType === 'above') {
			// 如果是基于第一条对话追加第一条对话
			if (!prevDialog) {
				state.insertDialog.baseRole.parent_dialog = 0 
				activeDialog.parent_dialog = state.insertDialog.baseRole.dialog_number
			} else { // 如果不是第一条对话 则修改 新增的 对话 的parent_dialog 为上一条对话的 dialog_number 
				state.insertDialog.baseRole.parent_dialog = prevDialog.dialog_number
				activeDialog.parent_dialog = state.insertDialog.baseRole.dialog_number
			}	
			state.dialogList.splice(activeDialogIndex,0,state.insertDialog.baseRole)
		} else {
			if (!nextDialog) {
				state.insertDialog.baseRole.parent_dialog = activeDialog.dialog_number
			} else { // 如果不是第一条对话 则修改 新增的 对话 的parent_dialog 为上一条对话的 dialog_number 
				state.insertDialog.baseRole.parent_dialog = activeDialog.dialog_number
				nextDialog.parent_dialog = state.insertDialog.baseRole.dialog_number
			}
			state.dialogList.splice(activeDialogIndex+1,0,state.insertDialog.baseRole)
		}
	},
	toggleAvatar(state, dialog) {
		state.modalData.modalType = 'toggleAvatar'
		state.modalData.isShowModal = true
		state.roleDialog = dialog
	},
	clearOptionInputStatus(state) { 
		const optionDialog = state.dialogList.filter(item => {
			return item.type === 3
		})
		if (optionDialog.length > 0) {
			optionDialog.forEach(item => {
				item.option_list.forEach(jtem => {
					jtem.isValue = true
				})
			})
		}
	},
	renderNewOption(state, optionType) { // 弹窗 新增一个 分支对话
		const newDialog = {
			id: 0,
			dialog_number: state.dialog_max_number + 1,
			role: 0,  
			image: '', 
			image_md5: '', 
			search_key: '', 
			title: "", // 对话内容
			type: 3,
			option_list: [
				{
					id: 1,
					jump: 0,
					search_key: `${state.dialog_max_number + 1}_1`,
					option: '...',
					parent_dialog: state.dialog_max_number + 1,
					isValue: false,
					isClose: false,
				},
				{
					id: 2,
					jump: 0,
					search_key: `${state.dialog_max_number + 1}_2`,
					option: '...',
					parent_dialog: state.dialog_max_number + 1,
					isValue: false,
					isClose: false,
				}
			]
		}
		if (optionType === 'input') {
			// 如果是新增一个分支对话，则需要检测是否为第一条数据，
			if(state.dialogList.length === 0) {
				newDialog.parent_dialog = 0
			} else {
				newDialog.parent_dialog = state.dialogList[state.dialogList.length -1].dialog_number
			}
			state.dialogList.push(newDialog)
		} else {
			const activeDialogIndex = state.dialogList.findIndex(item => {
				return item.dialog_number === state.insertDialog.baseRole.dialog_number
			})
			if (state.insertDialog.insertType === 'above') {
				// 如果是基于第一条对话追加第一条对话
				if (!state.dialogList[activeDialogIndex-1]) {
					newDialog.parent_dialog = 0 
					state.dialogList[activeDialogIndex].parent_dialog = newDialog.dialog_number
				} else { // 如果不是第一条对话 则修改 新增的 对话 的parent_dialog 为上一条对话的 dialog_number 
					newDialog.parent_dialog = state.dialogList[activeDialogIndex-1].dialog_number
					state.dialogList[activeDialogIndex].parent_dialog = newDialog.dialog_number
				}	
				state.dialogList.splice(activeDialogIndex,0,newDialog)
			} else {
				if (!state.dialogList[activeDialogIndex+1]) {
					newDialog.parent_dialog = state.dialogList[activeDialogIndex].dialog_number
				} else { // 如果不是第一条对话 则修改 新增的 对话 的parent_dialog 为上一条对话的 dialog_number 
					newDialog.parent_dialog = state.dialogList[activeDialogIndex].dialog_number
					state.dialogList[activeDialogIndex+1].parent_dialog = newDialog.dialog_number
				}
				state.dialogList.splice(activeDialogIndex+1,0,newDialog)
			}
		}
		state.editValue = ""
	},
	openDelDialogModal(state, dialog) {
		state.modalData.modalType = 'delDialog'
		state.modalData.isShowModal = true
		state.modalData.dialog = dialog
	},
	delDialog(state, dialog_number) { 
		// 删除对话需要增加一个弹窗
		// 删除原则为，每一条被删除的对话，都需要把下一条的对话含 parent_dialog 的值更新为 上一条对话的 dialog_number
		const activeIndex = state.dialogList.findIndex(item => {return item.dialog_number === dialog_number})
		const nextDialog = state.dialogList[activeIndex+1]
		const prevDialog = state.dialogList[activeIndex-1]
		
		if (nextDialog !== undefined) {
			if (prevDialog) {
				nextDialog.parent_dialog = prevDialog.dialog_number
			} else {
				nextDialog.parent_dialog = 0
			}
		} 	
		state.dialogList = state.dialogList.filter(item => item.dialog_number !== dialog_number)
	},
	delOptionLocalStorge(state, dialog) {
		dialog.option_list.forEach(item => {
			localStorage.removeItem(`option_${item.search_key}`) 
		})
	},
	initTextarea(state) { // 清空 Textarea 的值
		for (var i in state.branchTextarea) {
			state.branchTextarea[i] = ''
		}
	},
	addBranchFn(state, optionDialog) { 
		// 最多添加四条，后期如果不限制长度 去掉此判断即可
		if (optionDialog.option_list.length >= 4) {
			return false
		}
		const max_branchId = Math.max.apply(Math,optionDialog.option_list.map(item => { return item.id }))
		const branch = {
			id: max_branchId + 1,
			jump: 0,
			search_key: `${optionDialog.dialog_number}_${max_branchId + 1}`,
			option: '...',
			parent_dialog: optionDialog.dialog_number,
			isValue: false,
			isClose: false,
		}
		const activeOptionDialog = state.dialogList.find(item => {
			return item.dialog_number === optionDialog.dialog_number
		})
		activeOptionDialog.option_list.push(branch)
		// 如果branch 数量 > 2 则显示close icon 
		if (activeOptionDialog.option_list.length > 2) {
			activeOptionDialog.option_list.forEach(item => {
				item.isClose = true
			})
		}
	},
	delBranch(state, branchDialog) { // 删除 一条 分支类型的对话
		const activeOption = state.dialogList.find(item => {
			return item.dialog_number == branchDialog.parent_dialog
		})
		// 如果 branchDialog 数量大于2条，则可以 显示删除 icon
		if (activeOption.option_list.length > 2) {
			activeOption.option_list = activeOption.option_list.filter(item => {
				return item.id != branchDialog.id
			})
			// 如果branchDialog长度为2 则隐藏删除icon
			if (activeOption.option_list.length == 2) {
				activeOption.option_list.forEach(item => {
					item.isClose = false
				})
			}
		}
	},
	saveBranch(state, branchDialog) {
		const activeDialog = state.dialogList.find(item => {
			return item.dialog_number === branchDialog.parent_dialog
		})
		const activeBranch = activeDialog.option_list.find(item => {
			return item.id === branchDialog.id
		})
		activeBranch.option = state.branchTextarea[`${activeBranch.id}`]
		activeBranch.isValue = true
	},
	editBranch(state,branchDialog) { // 编辑分支内容
		const activeDialog = state.dialogList.find(item => {
			return item.dialog_number === branchDialog.parent_dialog
		})
		const activeBranch = activeDialog.option_list.find(item => {
			return item.id === branchDialog.id
		})
		activeBranch.isValue = false
		state.branchTextarea[`${activeBranch.id}`] = activeBranch.option
		// 查找当前的其他
		// 编辑输入限制在 当前 option 对话中，编辑当前，即需要关闭其他option的输入框
		const otherOption = state.dialogList.filter(item => {
			return item.dialog_number != branchDialog.parent_dialog && item.type === 3
		})
		if (otherOption.length > 0) {
			otherOption.forEach(item => {
				item.option_list.forEach(jtem => {
					jtem.isValue = true
				})
			})
		}	
	},
	updateBranchTextarea(state, {value,id}) { // 暂存输入框数据，每一个分支都是独立存在，单独用于存储数据
		state.branchTextarea[`${id}`] = value
	},
	clearDialogList(state, searchKey) { // 切换到新到对话框，需要重置对话列表 更新 seach_key
		state.dialogList = new Array()
		state.searchLocalId = searchKey
	},
	removeLocalStorgeData(state) {
		state.dialogList = new Array()
		localStorage.removeItem('previewData')
		Object.keys(localStorage).forEach(item => item.indexOf('option_') !== -1 ? localStorage.removeItem(item) : '')
	},
	getMaxDialogNumber(state) {
		let total_dialog = new Array()
		if (localStorage.getItem('option_1_dialogList') !== null) {
			const _dialogList = JSON.parse(localStorage.getItem('option_1_dialogList')) 
			if (_dialogList.length === 0) {
				state.dialog_max_number = 0
			} else {
				Object.keys(localStorage).forEach(item => {
					if (item.indexOf('option_') !== -1) {
						const _item = JSON.parse(localStorage.getItem(item))
						total_dialog = total_dialog.concat(_item)
					}
				})
				state.dialog_max_number = Math.max.apply(Math,total_dialog.map(item => { return item.dialog_number }))
			}
		}
	},
	max_dialog_number(state) {
		state.dialog_max_number += 1
	},
	getLocalStorgeDataFn(state) {
		let uploadData = new Array()
		Object.keys(localStorage).forEach(item => {
			if (item.indexOf('option_') !== -1) {
				let _item = JSON.parse(localStorage.getItem(item))
				const _search_key = item.slice(7)
				_item.forEach(Jtem => {
					if (_search_key !== '1_dialogList') {
						Jtem.search_key = _search_key
					} else {
						Jtem.search_key = ''
					}
					// 如果是分支对话类型
					if (Jtem.type === 3) {
						// 添加 jump 值
						Jtem.option_list.forEach(Ztem => {
							const _search_key = `option_${Ztem.search_key}`
							if (typeof localStorage[_search_key] !== 'undefined') {
								const branchDialogList = JSON.parse(localStorage.getItem(_search_key)) 
								if (branchDialogList.length > 0) {
									Ztem.jump = branchDialogList[0].dialog_number
								}
							}
						})	
					}
				})
				uploadData = uploadData.concat(_item)
			}
		})
		if (uploadData.length > 0) {
			return state.uploadData = uploadData
		} else {
			return state.uploadData = false
		}
	},
	_uploadImgDataFn(state, {axiosData,ImgData,uploadType}) {
		state.axiosData = axiosData
		state.uploadImgDialog = ImgData
		state.uploadType = uploadType
	},
	clickEvent() {
		let uploadDom = document.getElementById('upload_file')
		// IE浏览器
		if(!!window.ActiveXObject || "ActiveXObject" in window) {
			uploadDom.click();
		} else {
			var e = document.createEvent("MouseEvents");
			e.initEvent("click", true, true);
			uploadDom.dispatchEvent(e);
		}
	},
	changeUploadStatus(state) {
		state.isUploading = true
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}